import React, {useState, useEffect} from "react";
import {
    Container,
    Button,
    Tab,
    Tabs,
    ButtonGroup
} from "react-bootstrap";
import LoadingSpinner from "../toolkit/LoadingSpinner";
import {useNavigate} from "react-router-dom";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {displayYear, defaultAPPTITLE, defaultAPPLOGO, appVersion} from "../../config/global";
import {useSanctum} from "react-sanctum";
import UserForm from "../forms/UserForm";
import SubscriptionsAccordion from "../toolkit/SubscriptionsAccordion";
import UsersAccordion from "../toolkit/UsersAccordion";
import {useTranslation} from "react-i18next";
import {useAuthLocalStorage} from "../../hooks/useAuthLocalStorage";
import {useToolkit} from "../../hooks/useToolkit";
import {useEmailStorage} from "../../hooks/useEmailStorage";
import {useStockStorage} from "../../hooks/useStockStorage";


const Lounge = () => {
    const { t } = useTranslation();
    let navigate = useNavigate();

    const { getStockStorageToken, removeStockStorageToken, removeSessionStockAll } = useStockStorage();
    const {removeEmailStorageSent, setEmailStorageSent, emailStorageSent} = useEmailStorage();
    const {setCurrentTab, getCurrentTab, removeCurrentTab, removeCurrentQuote} = useToolkit();
    const [selectedTab, setSelectedTab] = useState(getCurrentTab());

    const [isLoading, setLoading] = useState(false)
    const [data, setData] = useState<any | null>(null)
    const {user} = useSanctum();
    const {removeAppUniqueToken, renewAppUniqueToken} = useAppUniqueToken();

    
    useEffect(() => {
        setLoading(true);

        removeCurrentTab();
        removeCurrentQuote();
        removeSessionStockAll();
        removeStockStorageToken();
        removeEmailStorageSent();
        renewAppUniqueToken();
        
        setLoading(false);
    }, []);

    /*
       useEffect(() => {
           setLoading(true);

           getLoungeData()
               .then(() => setLoading(false));
       }, []);

       const getLoungeData = async () => {

           let loungeData = await axios.get('api/lounge')
               .then(response => {
                   console.log('getLoungeData from axios: ' + response.data.lounge);
                   setData(response.data.lounge);

                   console.log(response.data.lounge);
               });
       };
       */

    const handleGoToHome = () => {
        removeCurrentTab();
        removeCurrentQuote();

        removeSessionStockAll();
        removeStockStorageToken();
        removeEmailStorageSent();
        

        navigate('/');
    }

    const handleLogout = () => {
        removeCurrentTab();
        removeCurrentQuote();
        removeAppUniqueToken();
    };


    const handleSelect = (e: any) => {
        setSelectedTab(e);
        setCurrentTab(e);
    }


    return (
        <Container fluid>
            {
                (
                    isLoading ?
                        <LoadingSpinner />
                        :
                        <div className="col col-12 mx-auto my-4">
                            <div className="panel center conferma">

                                <figure className="add_bottom_30">
                                    <a href={'#'} onClick={() => handleGoToHome()}>
                                    <img src={defaultAPPLOGO} height="100px" alt="" />
                                    </a><br />
                                    <h4> {defaultAPPTITLE}&nbsp;{displayYear}</h4>
                                    <span className="small fw-light">
                                        <span className="small fw-lighter">
                                        {appVersion}
                                        </span>
                                    </span>
                                </figure>

                                <center>
                                    <ButtonGroup size={'sm'} className={'mb-3'}>
                                        <Button variant="outline-success" onClick={handleGoToHome}>
                                            {t('captions.home')}
                                        </Button>
                                        <Button variant="outline-success" onClick={handleLogout}>
                                            {t('captions.logOut')}
                                        </Button>
                                    </ButtonGroup>
                                    <p>
                                        Area Riservata Utente
                                    </p>
                                </center>

                                <Tabs
                                    activeKey={selectedTab ? selectedTab : 'stocks'}
                                    onSelect={(e) => handleSelect(e)}
                                    id="main-tab"
                                >
                                    <Tab eventKey="stocks" title={t('captions.subscriptionRequests')} className={'p-3'}>
                                        <SubscriptionsAccordion />
                                    </Tab>
                                    {
                                        user && user.user.role !== 'ROLE_USER' && (
                                            <Tab eventKey="users" title={t('captions.userManagement')} className={'p-3'}>
                                                <UsersAccordion />
                                            </Tab>
                                        )
                                    }
                                    <Tab eventKey="profile" title={t('captions.yourProfile')} className={'p-3'}>
                                        <UserForm yourProfile={true} data={null}/>
                                    </Tab>
                                </Tabs>

                            </div>
                        </div>
                )
            }
            <div className="divider"></div>
        </Container>
    );
};

export default Lounge;
